import { SECONDS_PER_DAY } from "../math/constants";

/**
 * Manages simulation time advancement with acceleration and pause.
 */
export class TimeManager {
  private _currentTimeJD: number;
  timeAcceleration: number = 1.0;
  isPaused: boolean = false;

  /** Predefined acceleration levels */
  static readonly ACCELERATION_LEVELS = [1, 10, 100, 1000, 10000, 100000];

  constructor(startTimeJD: number) {
    this._currentTimeJD = startTimeJD;
  }

  get currentTimeJD(): number {
    return this._currentTimeJD;
  }

  /**
   * Advance simulation time by a real-world time delta.
   * @param realDeltaSeconds Real-world elapsed seconds
   * @returns Simulated time delta in days
   */
  advance(realDeltaSeconds: number): number {
    if (this.isPaused) return 0;

    const simDeltaSeconds = realDeltaSeconds * this.timeAcceleration;
    const simDeltaDays = simDeltaSeconds / SECONDS_PER_DAY;
    this._currentTimeJD += simDeltaDays;
    return simDeltaDays;
  }

  /** Set time directly (for initialization or time jumps). */
  setTime(jd: number): void {
    this._currentTimeJD = jd;
  }

  togglePause(): void {
    this.isPaused = !this.isPaused;
  }

  /** Get elapsed time since a start time in days. */
  elapsedDays(startTimeJD: number): number {
    return this._currentTimeJD - startTimeJD;
  }

  /** Get elapsed time since a start time in seconds. */
  elapsedSeconds(startTimeJD: number): number {
    return this.elapsedDays(startTimeJD) * SECONDS_PER_DAY;
  }
}
